











import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherGlobalSearch from '../TedsLauncherGlobalSearch/TedsLauncherGlobalSearch.vue'
import TedsLauncherProfileSection from '../TedsLauncherProfileSection/TedsLauncherProfileSection.vue'

@Component({
  components: {
    TedsLauncherGlobalSearch,
    TedsLauncherProfileSection,
  },
})
export default class TedsLauncherTopBar extends Vue {}
